"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cell_style_merger_1 = require("../merger/cell-style-merger");
/**
 * Resolving cell style including simple style and conditional formatting style
 *
 * Created by Hayk.Andriasyan on 4/18/2018.
 */
var CellStyleResolver = /** @class */ (function () {
    function CellStyleResolver(_simpleCellStyleResolver, _cellConditionalStyleResolver) {
        this._simpleCellStyleResolver = _simpleCellStyleResolver;
        this._cellConditionalStyleResolver = _cellConditionalStyleResolver;
    }
    /**
     * Get merged cell text style
     */
    CellStyleResolver.prototype.resolveValueCellStyle = function (rowBranchIndex, rowCategoryPathHolderId, columnBranchIndex, rowValues, cellIndex, leafsIndexToMeasureMetadataMap) {
        return this._resolveStyle(this._simpleCellStyleResolver.resolveValueCellStyle(rowBranchIndex, rowCategoryPathHolderId, columnBranchIndex), this._cellConditionalStyleResolver.resolveValueCellStyle(rowBranchIndex, rowCategoryPathHolderId, columnBranchIndex, rowValues, cellIndex, leafsIndexToMeasureMetadataMap));
    };
    CellStyleResolver.prototype.resolveRowCategoryItemStyle = function (rowBranchIndex, rowCategoryPathHolderId, rowValues) {
        return this._resolveStyle(this._simpleCellStyleResolver.resolveRowCategoryItemStyle(rowBranchIndex, rowCategoryPathHolderId), this._cellConditionalStyleResolver.resolveRowCategoryItemStyle(rowBranchIndex, rowCategoryPathHolderId, rowValues));
    };
    CellStyleResolver.prototype.resolveValueCellStyleWithoutRowGrouping = function (columnBranchIndex, rowValue, leafsIndexToMeasureMetadataMap) {
        return this._resolveStyle(this._simpleCellStyleResolver.resolveValueCellStyleWithoutRowGrouping(columnBranchIndex), this._cellConditionalStyleResolver.resolveValueCellStyleWithoutRowGrouping(columnBranchIndex, rowValue, leafsIndexToMeasureMetadataMap));
    };
    CellStyleResolver.prototype._resolveStyle = function (simpleTextStyle, conditionalTextStyle) {
        var styles = [];
        if (simpleTextStyle) {
            styles.push(simpleTextStyle);
        }
        if (conditionalTextStyle) {
            styles.push(conditionalTextStyle);
        }
        return cell_style_merger_1.CellStyleMerger.mergeTextStyles(styles);
    };
    return CellStyleResolver;
}());
exports.CellStyleResolver = CellStyleResolver;
//# sourceMappingURL=cell-style-resolver.js.map